import { Dialog, Transition } from '@headlessui/react'
import { XIcon } from '@heroicons/react/outline'
import Image from 'next/image'
import { Fragment, useEffect } from 'react'
import { AffiliateWP } from '../../helpers/Affiliate'
import { ModalStore } from '../../state/ModalStore'

/**
 *
 * @TODO should cache results incase user check again
 */
export default function TurboLetterModal() {
    const skimModal = ModalStore((state) => state.skim)

    const handleMount = () => {
        const timeout = setTimeout(skimModal, 5000)
        AffiliateWP.init({
            query: {
                ref: '46',
            },
            asPath: process.env.NEXT_PUBLIC_APP_LINK,
        })
        return timeout
    }

    useEffect(() => {
        const timeout = handleMount()
        return () => clearTimeout(timeout)
    }, [])
    return (
        <>
            <Transition appear show={true} as={Fragment}>
                <Dialog
                    as="div"
                    className="fixed inset-0 z-10 overflow-y-auto"
                    onClose={skimModal}>
                    <div className="min-h-screen px-4 text-center">
                        <Dialog.Overlay className="fixed inset-0 bg-black opacity-30 pointer-events-none" />
                        {/* This element is to trick the browser into centering the modal contents. */}
                        <span
                            className="inline-block h-screen align-middle"
                            aria-hidden="true">
                            &#8203;
                        </span>
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95">
                            <div className="inline-block w-full max-w-3xl p-6 my-8 overflow-hidden text-left align-middle transition-all transform ">
                                <div className="text-right">
                                    <button
                                        type="button"
                                        className="inline-flex justify-center px-4 py-2 text-sm font-medium orange-blue-900
                                          bg-olm border border-transparent
                                          text-white
                                          space-x-1
                                           hover:bg-olh focus:outline-none"
                                        onClick={skimModal}>
                                        <XIcon className="h-5 w-5" />
                                        <span>Close</span>
                                    </button>
                                </div>
                                <div className="mx-auto border bg-white p-10 text-center md:p-20">
                                    <div
                                        className="md:flex md:justify-between
                                    space-y-5
                                    justify-center text-center items-center">
                                        <p>
                                            <img
                                                className="h-24 m-auto"
                                                src="/assets/turboletter.png"
                                            />
                                        </p>

                                        <p>
                                            <img
                                                className="h-24 m-auto"
                                                src="/assets/handshake.png"
                                            />
                                        </p>

                                        <p>
                                            <Image
                                                height="39"
                                                width="169"
                                                src="/assets/OLM_Logo-1.svg"
                                            />
                                        </p>
                                    </div>

                                    <p className="text-center mt-10 md:mt-20 font-semibold text-xl">
                                        Turbo Letters is now partnered with Open
                                        Letter Marketing.
                                    </p>
                                </div>
                            </div>
                        </Transition.Child>
                    </div>
                </Dialog>
            </Transition>
        </>
    )
}
